<template>
  <div class="mx-8">
    <div class="grid-container">
      <div ref="gridWrapper" class="grid-wrapper w-full" :style="{ width: this.realWidthOfGrid + 'px' }">
        <div ref="ordersWrapper" class="orders-wrapper">
          <div v-for="order in orders"
            :key="order.id"
            class="order"
            :id="order.id"
            v-memo="[order.image_name]" 
            :data-coords="`${order.coords_x_left},${order.coords_y_top},${order.coords_x_right},${order.coords_y_bottom}`"
            :data-image-status="`${order.image_status}`"
            :style="getOrderStyle(order)">
            
            <!-- Clickable Link -->
            <a :href="order.url" target="_blank" :title="order.display_text">
              <!-- Image -->
              <img v-if="order.image_status && order.image_status != 2" 
                :src="`${uploadsUrl}/${order.image_name}`"
                :alt="order.display_text"
                loading="lazy"
                fetchpriority="low" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <teleport to="#app">
    <transition name="modal-fade">
      <div v-if="this.showInstruction && this.isTouchDevice" class="fixed top-0 left-0 w-full h-full z-900 shadow-md bg-black bg-opacity-70 modal-bg" >
        <div class="sticky top-0 flex items-start justify-center min-h-screen text-center">
          <div ref="target" class="absolute w-screen h-screen bg-white p-2 shadow-xl modal-content opacity-90" role="dialog" aria-modal="true">
            <div class="w-full h-full flex flex-col items-center justify-center">
              
              <img src="../assets/images/pinch.gif" style="width: min(50%, 25vh) ;"/>
              <h1 class="text-xl font-bold top-2">Use two fingers to move around</h1>
              <img src="../assets/images/swipe.gif" style="width: min(45%, 21vh) ;"/>
              <h1 class="text-xl font-bold top-2">Use one finger to select</h1>
              <button @click.stop="dismissInstruction" class="btn btn-light" style="margin-top: 100px;">Got it!</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal-fade">
    <div v-if="this.letsCreateOrder" class="fixed top-0 left-0 w-full h-full z-900 shadow-md p-4 bg-black bg-opacity-70 modal-bg" @click.self="cancelNewOrder" id="newOrderModal">
      <div class="sticky top-5 flex items-start justify-center min-h-screen mt-24 text-center">
        <div ref="target" class="bg-white p-2 shadow-xl w-full max-w-md modal-content" role="dialog" aria-modal="true">
          <!-- Close button in the top-right corner -->
          <button 
            @click="cancelNewOrder" 
            class="top-2 right-2 text-gray-600 hover:text-gray-900 btn-close"
            aria-label="X"
          >
            <img src="../assets/images/icon-close.png" alt="X" width="40" height="40">
          </button>
          <div class="modal-header" style="">
            <h1 class="text-xl font-bold top-2">New spot {{ newOrder.px_horizontal / 10 }}x{{ newOrder.px_vertical / 10 }} squares</h1>
            <p>That's {{ newOrder.px_horizontal || null }}x{{ newOrder.px_vertical || null }} px</p>
            <h1 class="text-xl font-bold top-2">Amount: {{ newOrder.amount || 0 }} XRP</h1>
          </div>

          <!-- Progress Bar -->
          <div class="w-full progress-wrapper">
            <div 
              class="progress-bar"
              :style="{ width: progressPercentage + '%' }"
            >
              <p :style="{ paddingRight: (Math.max(13,(100 - progressPercentage)) * 0.6 ) + '%' }">{{ displayStep }} / 4</p>
            </div>
          </div>
   
          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 1" class="step step-1">
            <h2 class="text-xl mb-4">Upload your wall image</h2>

            <div v-if="!this.newOrder.image || !this.imgUrl" class="image-select flex items-center justify-center">
                <a class="btn btn-outline-light" @click.prevent="launchChooseFile">Upload image</a>
            </div>

            <div v-if="this.newOrder.image && this.imgUrl" class="image-wrapper flex items-center justify-center">
              <button 
                @click="deleteImage" 
                class="text-gray-600 hover:text-gray-900 btn-close btn-remove"
                aria-label="X"
              >
                Remove upload
              </button>
              <img :src="this.imgUrl" class="preview"/>
            </div>
            <input 
              ref="imageInput" 
              type="file" 
              name="image" 
              class="image" 
              accept="image/*"
              single 
              @change="handleImageUpload"
            />
            <div class="flex justify-center mt-4 step-btns">
              <button @click="forwardStep" class="btn btn-light btn-multi">Next</button>
            </div>
          </div>
          </transition>

          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 2">
            <h2 class="text-xl mb-4">Give your spot a display text and a link</h2>
            <div class="form-group-wrapper"> 
              <div class="form-group">
                <!--<label for="displayText">Text others will see when hovering your spot</label>-->
                <input 
                  id="displayText"
                  type="text" 
                  v-model="newOrder.display_text" 
                  :maxlength="200" 
                  placeholder="Enter a display text of your spot"
                />
              </div>
              <div class="form-group">
                <!--<label for="url">Url that gets open when pressing your spot</label>-->
                <input 
                  id="url"
                  type="url" 
                  v-model="newOrder.url" 
                  placeholder="Enter a URL for your spot"
                  :pattern="urlPattern"
                />
              </div>
              <div class="form-group">
                <!--<label for="url">Url that gets open when pressing your spot</label>-->
                <input 
                  id="affiliate"
                  type="text" 
                  v-model="newOrder.affiliate_code" 
                  placeholder="Enter affiliate code if available"
                />
              </div>
            </div>
            <div class="flex justify-center mt-4 step-btns">
              <button @click="prevStep" class="btn btn-secondary mr-8">Back</button>
              <button @click="forwardStep" class="btn btn-light btn-multi ml-8">Next</button>
            </div>
          </div>
          </transition>

          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 3">
            <h2 class="text-xl mb-4" >Provide your contacts just in case</h2>
            <div class="form-group-wrapper"> 
              <div class="form-group">
                <font-awesome-icon :icon="['fas', 'envelope']" style="color: #3185fc;" class="icon-for-input"/>
                <input 
                  id="email"
                  type="email" 
                  v-model="newOrder.email" 
                  placeholder="Enter e-mail"
                  class="input-with-icon"
                />
              </div>
              <div class="form-group">
                <font-awesome-icon :icon="['fab', 'x-twitter']" style="color: #3185fc;" class="icon-for-input"/>
                <input 
                  id="x"
                  type="text" 
                  v-model="newOrder.twitter" 
                  placeholder="Enter X handle"
                  class="input-with-icon"
                />
              </div>
              <div class="form-group">
                <font-awesome-icon :icon="['fab', 'discord']" style="color: #3185fc;" class="icon-for-input"/>
                <input 
                  id="discord"
                  type="text" 
                  v-model="newOrder.discord" 
                  placeholder="Enter Discord"
                  class="input-with-icon"
                />
              </div>
            </div>
            <div class="flex justify-center mt-4 step-btns">
              <button @click="prevStep" class="btn btn-secondary mr-8">Back</button>
              <button class="btn btn-light btn-multi ml-8"  @click="authorize" ref="connectWalletButton" v-if="this.customerAcc == null">Sign in <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
              <button class="btn btn-light btn-multi ml-8"  @click="pay" ref="disconnectWalletSpan" v-if="this.customerAcc !== null"> Pay <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
            </div>
          </div>
          </transition>

          <transition name="fade-center" @after-leave="handleAfterLeave">
          <div v-if="currentStep === 4">

            <h2 v-if="this.orderCreated == false" class="text-xl mb-4">Pay with Xaman</h2>
            <h2 v-if="this.orderCreated == true" class="text-xl mb-4">Congratulations!</h2>

            <div v-if="this.waitingForPost == false && this.orderCreated == false" class="payment-info-wrapper mt-2 flex justify-center items-center flex-col w-full px-10"> 
              <p v-if="this.paymentNotSigned == false" class="mb-3" style="color: gray;">You should receive a notification in Xaman App</p>
              <img class="xaman-icon" :src="this.paymentInfo.qr" width="50%"/>
              <p v-if="!this.paymentInfo.qr">No payment QR code available.</p>
              <p v-if="this.paymentInfo.url">If no notification, scan this QR code or <br><a target="_blank" v-bind:href="this.paymentInfo.url"> press on this link.</a></p>
              <p v-if="!this.paymentInfo.url">No payment link available.</p>
              <p v-if="!this.paymentInfo.qr && !this.paymentInfo.url">Try pressing Pay button.</p>
              <div v-if="this.paymentNotSigned == false" class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>

            <div v-if="this.waitingForPost == true" class="submit-info-wrapper mt-2 flex justify-center items-center flex-col w-full px-10"> 
              <p class="mb-3" style="color: gray;">Saving your order to Million XRP Wall. Please wait...</p>
              <div class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>

            <div v-if="this.orderCreated == true" class="cuccess-wrapper mt-2 flex justify-center items-center flex-col w-full px-10"> 
              <p class="mb-3">You are now the owner of the pixels of XRP wall!</p>
              <p class="mb-3">Order number: {{ newOrder.number }}<br>
                Tx hash: <a target="_blank" v-bind:href="'https://'+ this.network + '.xrpl.org/transactions/' + newOrder.tx_hash">{{ newOrder.tx_hash.substring(0,8) }}...</a><br>
                You can also check your spot in <a v-bind:href="this.profileUrl">Profile</a>.
              </p>
              <img class="xrp-astronout" src="../assets/images/xrp-astronout-on-planet.png" style="width: 50%;"/>

            </div>

            <div class="flex justify-center mt-4 step-btns">
              <button @click="prevStep" class="btn btn-secondary mr-8" v-if="this.orderCreated == false">Back</button>
              <button class="btn btn-light btn-multi ml-8"  @click="authorize" ref="connectWalletButton" v-if="this.customerAcc == null && this.orderCreated == false">Sign in <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
              <button class="btn btn-light btn-multi ml-8"  @click="pay" ref="disconnectWalletSpan" v-if="this.customerAcc !== null && this.paymentNotSigned == true && this.orderCreated == false"> Pay <img class="xaman-icon" src="../assets/images/xaman-icon.jpg"/></button>
            </div>
          </div>
          </transition>
        </div>
      </div>
    </div>
    </transition>
  </teleport>
</template>

<script>
import axios from 'axios';
import { toast } from 'vue3-toastify';
import { ref } from 'vue';

const show = ref(true)
show.value = true

export default {
  name: 'PixelGrid',
  data () {
    return {
      showInstruction: false,
      network: process.env.VUE_APP_NETWORK,
      profileUrl: process.env.VUE_APP_PROFILE_URL,
      uploadsUrl: process.env.VUE_APP_API_IMAGE,
      letsCreateOrder: false,
      currentStep: 1,  // Tracks the current step
      nextStep: 2,  // Stores the next step temporarily
      displayStep: 1, // Stores step for .progress-bar
      newOrderIsOverlapping: false,
      scale: 1, // Initial zoom level
      translateX: 0,
      translateY: 0,
      startX: null, // Mousdown or touch[1] for starting to draw
      startY: null, // Mousdown or touch[1] for starting to draw
      coordsXleft: null, // For coords
      coordsXright: null, // For coords
      coordsYup: null, // For coords
      coordsYdown: null, // For coords
      visualXleft: null, // For drawing
      visualXright: null, // For drawing
      visualYup: null, // For drawing
      visualYdown: null, // For drawing
      isDrawing: false, // For drawing
      rectColor: process.env.VUE_APP_COLOR_SECOND, // Default rectangle color (blue)
      rectOpacity: 1, // Default rectangle opacity (fully opaque)
      squareSize: null,
      gridScale: null,
      zoomLevel: 1,
      ordersWrapper: null,
      gridWrapper: null,
      orders: [], // Full list of orders
      visibleOrders: [], // Orders currently being rendered
      currentIndex: 0, // Tracks which order is currently visible
      imgUrl: null,
      newOrder: { 
        number: null,
        client_address: null,
        amount: null,
        currency: 'XRP',
        coords_x_left: null,
        coords_y_top: null,
        coords_x_right: null,
        coords_y_bottom: null,
        px_horizontal: null,
        px_vertical: null,
        tx_hash: null,
        image: null,      
        url: null,
        display_text: null,
        email: null,
        twitter: null,
        discord: null,
        affiliate_code: null
      },
      paymentInfo: {
        url: null,
        qr: null,
        show: false
      },
      ordersAreFetched: false,
      paymentNotSigned: false,
      waitingForPost: false,
      orderCreated: false,
      baseWidthOfGrid: null,
      realWidthOfGrid: null,
      baseWidthOfApp: null,
      isTouchDevice: navigator.maxTouchPoints > 0,
      isPanning: false,
    }
  },

  props: {
    customerAcc: String ,
    authorize: Function,
    isValidUrl: Function,
    isValidXRPAddress: Function,
    hexEncode: Function,
    hexDecode: Function,
    urlPattern: String,
  },

  computed: {
    imageStyle () {
      return {
        transform: `scale(${this.scale}) translate(${this.translateX}px, ${this.translateY}px)`,
        transition: this.isPanning ? 'none' : 'transform 0.2s ease'
      }
    },

    progressPercentage() {
      return (this.displayStep / 4) * 100;
    },
  },

  mounted () {
    if (!localStorage.getItem("navigationInstructionSeen")) {
      this.showInstruction = true;
    }

    this.fetchOrders(); // Fetch orders when the component is mounted
    this.ordersWrapper = this.$refs.ordersWrapper
    this.gridWrapper = this.$refs.gridWrapper

    // Add mouse event listeners
    this.ordersWrapper.addEventListener('mousedown', event => {
      if(!this.customerAcc || this.customerAcc == null) {
        toast.warning('Sign in with Xaman to purchase or manage your pixels!', { icon: false, });
      }
      else if(this.isTouchDevice === false) {
        this.startDrawing(event);
      }
    })

    this.ordersWrapper.addEventListener('mousemove', event => {
      if(this.isTouchDevice === false) {
        this.drawRectangle(event);
      }
    })

    this.ordersWrapper.addEventListener('mouseup', event => {
      console.log(event);
      if(this.isTouchDevice === false) {
        this.stopDrawing();
      }
    })

    // Add touch event listeners
    document.addEventListener('touchstart', event => {
      if(event.touches && event.touches.length > 1) {
        this.isPanning = true;
      } else {
        console.log(event)
        this.isPanning = false;
      }
    }, { passive: true })

    document.addEventListener('touchmove', event => {
      if(event.touches && event.touches.length > 1) {
        this.isPanning = true;
      } else {
        this.isPanning = false;
      }
    }, { passive: true })

    this.ordersWrapper.addEventListener('touchstart', event => {
      if (this.isTouchDevice === true && 
      this.isPanning === false &&
      event.touches && 
      event.touches.length === 1 && 
      event.targetTouches && 
      event.targetTouches.length === 1) {
        
        event.preventDefault();

        if(!this.customerAcc || this.customerAcc == null) {
          toast.warning('Sign in with Xaman to purchase or manage your pixels!', { icon: false, });
        }
        else {
          this.startDrawing(event);
          this.drawRectangle(event);
        }
      }
    }, { passive: false })

    this.ordersWrapper.addEventListener('touchmove', event => {
      if (this.isTouchDevice === true && 
      this.isPanning === false &&
      event.touches && 
      event.touches.length === 1 && 
      event.targetTouches && 
      event.targetTouches.length === 1) {
        event.preventDefault();
        this.drawRectangle(event);
      }
    }, { passive: false })

    this.ordersWrapper.addEventListener('touchend', event => {
      console.log(event);
      if (this.isTouchDevice) {
        this.stopDrawing();
      }
      console.log('devicePixelRatio:'+window.devicePixelRatio)
    })
    
    this.baseWidthOfGrid = this.gridWrapper.getBoundingClientRect().width * window.devicePixelRatio
    this.baseWidthOfApp = document.getElementById('app').getBoundingClientRect().width * window.devicePixelRatio
    console.log('---Initial baseWidthOfApp=' + this.baseWidthOfApp)
    console.log('---Initial baseWidthOfGrid=' + this.baseWidthOfGrid)

    if(this.isTouchDevice === false || window.width > 1024) {
      window.addEventListener('resize', () => { this.setGridBaseWidth(); })
    }    
  },
  unmounted () {
    // Remove mouse event listeners
    this.ordersWrapper.removeEventListener('mousedown', this.startDrawing)
    this.ordersWrapper.removeEventListener('mousemove', this.drawRectangle)
    this.ordersWrapper.removeEventListener('mouseup', this.stopDrawing)

    // Remove touch event listeners
    this.ordersWrapper.removeEventListener('touchstart', event)
    this.ordersWrapper.removeEventListener('touchmove', event)
    this.ordersWrapper.removeEventListener('touchend', event)
  },
  methods: {
    setGridBaseWidth() {
      this.realWidthOfGrid = Math.max(this.baseWidthOfGrid, this.baseWidthOfGrid * window.devicePixelRatio)
      this.realWidthOfApp = Math.max(this.baseWidthOfApp, this.baseWidthOfApp * window.devicePixelRatio)
      document.body.style.width = this.realWidthOfApp + 'px'
      console.log('this.realWidthOfApp=' + this.realWidthOfApp)
      console.log('this.baseWidthOfGrid=' + this.baseWidthOfGrid)
      console.log('window.devicePixelRatio=' + window.devicePixelRatio)
      console.log('this.realWidthOfGrid=' + this.realWidthOfGrid)
    },

    dismissInstruction() {
      this.showInstruction = false;
      localStorage.setItem("navigationInstructionSeen", "true");
    },

    isVisible(order) {
      // Return true if the item is within both the x and y bounds
      return order.coords_x_left * 0.1 < window.innerWidth && order.coords_x_right * 0.1 > 0 && order.coords_y_top * 0.1 < window.innerHeight && order.coords_y_bottom * 0.1 > 0;
    },

    getOrderStyle(order) {
      const scale = 0.1;
      return {
        width: `${(order.coords_x_right - order.coords_x_left + 1) * scale}%`,
        height: `${(order.coords_y_bottom - order.coords_y_top + 1) * scale}%`,
        top: `${order.coords_y_top * scale}%`,
        left: `${order.coords_x_left * scale}%`,
        position: 'absolute',
      };
    },

    getLivePosition (event) {
      if (event.touches && event.touches.length === 1 && event.targetTouches && event.targetTouches.length === 1) {
        // For touch events
        return {
          x: event.targetTouches[0].clientX - this.ordersWrapper.getBoundingClientRect().left,
          y: event.targetTouches[0].clientY - this.ordersWrapper.getBoundingClientRect().top
        }
      } else {
        // For mouse events
        return {
          x: event.clientX - this.ordersWrapper.getBoundingClientRect().left,
          y: event.clientY - this.ordersWrapper.getBoundingClientRect().top
        }
      }
    },

    startDrawing (event) {
      this.isDrawing = true
      this.letsCreateOrder = false
      this.startX = this.getLivePosition(event).x
      this.startY = this.getLivePosition(event).y

      this.coordsXleft = Math.floor(this.startX / this.ordersWrapper.getBoundingClientRect().width * 100) * 10
      this.coordsXright = Math.floor(this.getLivePosition(event).x / this.ordersWrapper.getBoundingClientRect().width * 100) * 10 + 9

      this.coordsYup = Math.floor(this.startY / this.ordersWrapper.getBoundingClientRect().height * 100) * 10
      this.coordsYdown = Math.floor(this.getLivePosition(event).y / this.ordersWrapper.getBoundingClientRect().height * 100) * 10 + 9
    },

    drawRectangle (event) {
      if (this.isDrawing && (this.getLivePosition(event).x < 0 || this.getLivePosition(event).x > this.ordersWrapper.getBoundingClientRect().width || 
      this.getLivePosition(event).y < 0 || this.getLivePosition(event).y > this.ordersWrapper.getBoundingClientRect().height)) {
        this.stopDrawing()
        return
      }

      // Setup Scale
      this.gridScale = this.ordersWrapper.getBoundingClientRect().width / 1000
      this.squareSize = this.ordersWrapper.getBoundingClientRect().width  * 0.01
      
      if (this.squareSize && this.gridScale) {
        // Check if drawing
        if (this.isDrawing && this.startX && this.startY) {
          if (this.getLivePosition(event).x >= this.startX) {
            // Drawing to the right
            this.coordsXleft = Math.floor(this.startX / this.ordersWrapper.getBoundingClientRect().width * 100) * 10
            this.coordsXright = Math.floor(this.getLivePosition(event).x / this.ordersWrapper.getBoundingClientRect().width * 100) * 10 + 9
          } else {
            // Drawing to the left
            this.coordsXleft = Math.floor(this.getLivePosition(event).x / this.ordersWrapper.getBoundingClientRect().height * 100) * 10
            this.coordsXright = Math.floor(this.startX / this.ordersWrapper.getBoundingClientRect().height * 100) * 10 + 9
          }
          
          if (this.getLivePosition(event).y >= this.startY) { // Drawing downwards
            this.coordsYup = Math.floor(this.startY / this.ordersWrapper.getBoundingClientRect().height * 100) * 10
            this.coordsYdown = Math.floor(this.getLivePosition(event).y / this.ordersWrapper.getBoundingClientRect().height * 100) * 10 + 9
          } else { // Drawing upwards
            this.coordsYup = Math.floor(this.getLivePosition(event).y / this.ordersWrapper.getBoundingClientRect().height * 100) * 10
            this.coordsYdown = Math.floor(this.startY / this.ordersWrapper.getBoundingClientRect().height * 100) * 10 + 9
          }

          this.coordsXleft = Math.max(0, this.coordsXleft)
          this.coordsYup = Math.max(0, this.coordsYup)
          this.coordsXright = Math.min(999, this.coordsXright)
          this.coordsYdown = Math.min(999, this.coordsYdown)

          // Set visual representation
          if(this.isTouchDevice) {
            this.visualXleft = this.coordsXleft * this.gridScale * 0.999
            this.visualYup = this.coordsYup * this.gridScale * 0.999
          } else {
            this.visualXleft = this.coordsXleft * this.gridScale * 0.999
            this.visualYup = this.coordsYup * this.gridScale * 0.999 + 2
          }

          // Draw  square
          this.draw(this.visualXleft, this.visualYup, (this.coordsXright - this.coordsXleft) * this.gridScale, (this.coordsYdown - this.coordsYup) * this.gridScale)
        } else {

          // Coordinations
          this.coordsXleft = Math.floor(this.getLivePosition(event).x / this.ordersWrapper.getBoundingClientRect().width * Math.ceil(1,this.gridScale) * 100) * 10
          this.coordsYup = Math.floor(this.getLivePosition(event).y / this.ordersWrapper.getBoundingClientRect().height * Math.ceil(1,this.gridScale) * 100) * 10

          // Scaled visual representation of Coordinations
          this.visualXleft = this.coordsXleft  * this.gridScale * 0.999
          this.visualYup = this.coordsYup  * this.gridScale * 0.999

          //console.log('===================')
          //console.log('scale=' + this.scale)
          //console.log('gridScale=' + this.gridScale)
          //console.log('squareSize=' + this.squareSize)
          //console.log('getLivePosition(event).x=' + this.getLivePosition(event).x)
          //console.log('getLivePosition(event).y=' + this.getLivePosition(event).y)
          //console.log('coordsXleft=' + this.coordsXleft)
          //console.log('coordsYup=' + this.coordsYup)

          // Draw  square
          this.draw(this.visualXleft, this.visualYup, this.squareSize, this.squareSize)
        }
      }
    },

    draw(x, y, width, height) {
      x = x / this.zoomLevel;
      y = y / this.zoomLevel;
      width = width / this.zoomLevel;
      height = height / this.zoomLevel;

      // Clear previous
      document.querySelectorAll('.drawn-div').forEach(element => element.remove());

      // Create a new div element
      const newDiv = document.createElement('div');

      // Add a CSS class for styling
      newDiv.classList.add('drawn-div');

      // Set styles dynamically
      newDiv.style.position = 'absolute'; // Ensure proper positioning
      newDiv.style.left = `${x}px`;
      newDiv.style.top = `${y}px`;
      newDiv.style.width = `${width}px`;
      newDiv.style.height = `${height}px`;
      newDiv.style.backgroundColor = process.env.VUE_APP_COLOR_SECOND;
      newDiv.style.opacity = 0.8;

      // Append the div to the grid wrapper
      if (this.$refs.gridWrapper) {
        this.$refs.gridWrapper.appendChild(newDiv);
      } else {
        console.error('gridWrapper is not defined');
      }
    },

    stopDrawing () {
      // Quick mouse click fix
      if(!this.coordsXright || this.coordsXright == null) {
        this.coordsXright = this.coordsXleft + 9;
      }
      if(!this.coordsYdown || this.coordsYdown == null) {
        this.coordsYdown = this.coordsYup + 9;
      }
      if(!this.coordsXleft) {
        this.coordsXleft = 0;
      }
      if(!this.coordsYup) {
        this.coordsYup = 0;
      }

      if(this.isDrawing && 
          (this.coordsXleft < 0 || this.coordsXleft > 990 ||
          this.coordsYup < 0 || this.coordsYup > 990 ||
          this.coordsXright < 9 || this.coordsXright > 999 ||
          this.coordsYdown < 9 || this.coordsYdown > 999 ||
          this.coordsXleft > (this.coordsXright - 9) ||
          this.coordsYup > (this.coordsYdown - 9))
      ) {
        toast.error('Browser messed up some pixels.\nTry again or reload the page.', { icon: false, });
        this.isDrawing = false;
        return;
      }
      
      if (this.isDrawing && this.coordsXleft >= 0 && this.coordsYup >=0 && this.coordsXright <= 999 && this.coordsYdown <= 999) {
        // Stop drawing
        this.isDrawing = false 
        
        // Set selected square
        this.newOrder.coords_x_left = this.coordsXleft
        this.newOrder.coords_y_top = this.coordsYup
        this.newOrder.coords_x_right = this.coordsXright
        this.newOrder.coords_y_bottom = this.coordsYdown
        this.newOrder.px_horizontal = this.newOrder.coords_x_right - this.newOrder.coords_x_left + 1
        this.newOrder.px_vertical = this.newOrder.coords_y_bottom - this.newOrder.coords_y_top + 1
        this.newOrder.amount = this.newOrder.px_horizontal * this.newOrder.px_vertical / 10

        if (!this.ordersAreFetched || !Array.isArray(this.orders) || this.orders.length < 1) {
          toast.error('There was a problem loading existing spots.\nTry reloading the page.', { icon: false, });
        } else if(this.orderIsOverlaping() == true) {
          this.newOrderIsOverlapping = true
          this.letsCreateOrder = false
          toast.error('Your selection overlaps others.\nSelect a free spot.', { icon: false, });
          this.cancelNewOrder()
        } else {
          this.currentStep = 1
          this.newOrderIsOverlapping = false
          this.letsCreateOrder = true
        }
      }
    },

    orderIsOverlaping() {
      // Check if any order overlaps with the new order
      return this.orders.some(order => {
        // Check if there is an overlap
        return !(this.newOrder.coords_x_left >= order.coords_x_right ||
          this.newOrder.coords_y_top >= order.coords_y_bottom ||
          this.newOrder.coords_x_right <= order.coords_x_left ||
          this.newOrder.coords_y_bottom <= order.coords_y_top);
      });
    },

    // Fetch orders from the backend
    async fetchOrders() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}`); 
        if (response.status === 200 && response.data.length > 0) {
          this.ordersAreFetched = true;
          this.orders = response.data;

          this.$nextTick(() => {
            const orderDivs = document.querySelectorAll(".order");
            const observer = new IntersectionObserver(
              entries => {
                entries.forEach(entry => {
                  // Get the child <img> element inside the observed order
                  const imgElement = entry.target.querySelector('a img'); // Targeting <img> inside <a>

                  // Check if the <img> exists and toggle the class on it
                  if (imgElement) {
                    imgElement.classList.toggle("order-hidden", !entry.isIntersecting);
                  }
                });
              }
            );
          
            orderDivs.forEach(orderDiv => {
              observer.observe(orderDiv)
            });
          });
          
        } else {
          this.ordersAreFetched = false;
          toast.warning('Failed to get existing pixels.\nTry reloading.', { icon: false });
        }
      } catch (error) {
        toast.error('Failed to get existing pixels.\nTry reloading.', { icon: false });
      }
    },

    forwardStep() {
      this.displayStep = this.currentStep
      // Check image
      if(this.currentStep === 1 && (!this.newOrder.image || !this.imgUrl)) {
        toast.error('No image...\nUpload an image to continue.', { icon: false, });
        return;
      }
      else if (this.currentStep === 2) {
        // Check display_text
        if(!this.newOrder.display_text || this.newOrder.display_text == null) {
          toast.warning('Display text was left empty.\nYou can add it later if you want.', { icon: false, });
        } 
        //Check url
        if(!this.newOrder.url || this.newOrder.url == null) {
          toast.warning('Url was left empty.\nYou can add it later if you want.', { icon: false, });
        } else if(!this.isValidUrl(this.newOrder.url)) {
          toast.error('Invalid url.\nYou should fix this.', { icon: false, });
          return;
        }
      } else if(this.currentStep > 3) {
        return;
      }
      
      this.changeStep(this.currentStep + 1)
    },

    prevStep() {
      if(this.currentStep == 4) {
        this.paymentInfo.url = null,
        this.paymentInfo.qr = null,
        this.paymentNotSigned = false
      }

      this.displayStep = this.currentStep
      if (this.currentStep > 1) this.changeStep(this.currentStep - 1)
    },

    changeStep(step) {
      this.nextStep = step;  // Store the next step
      this.currentStep = null;  // Trigger slide-out first
    },

    handleAfterLeave() {
      this.currentStep = this.nextStep;  // Perform slide-in after slide-out completes
      this.displayStep = this.currentStep
    },

    cancelNewOrder() {
      this.letsCreateOrder = false
      this.newOrder.coords_x_left = null
      this.newOrder.coords_y_top = null
      this.newOrder.coords_x_right = null
      this.newOrder.coords_y_bottom = null
      this.newOrder.client_address = null
      this.newOrder.amount = null
      this.newOrder.px_horizontal = null
      this.newOrder.px_vertical = null
      this.newOrder.tx_hash = null
      this.newOrder.image = null
      this.step = 1
      this.nextStep = 2
      this.paymentInfo.url = null
      this.paymentInfo.qr = null
      this.paymentNotSigned = false
      this.newOrderIsOverlapping = false
      this.orderCreated = false
      this.waitingForPost = false
    },

    launchChooseFile() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const file = event.target.files[0];

      if (!file) {
        toast.error('No image seleted.\nTry again.', { icon: false, });
        return;
      }

      // Validate file type (only allow images)
      if (!file.type.startsWith('image/')) {
        toast.error('Only image files are allowed.\nTry again.', { icon: false, });
        this.newOrder.image = null;
        this.imgUrl = null;
        return;
      }

      // Validate file size (max 5 MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('Image is too large.\n5 MB are allowed.', { icon: false, });
        this.newOrder.image = null;
        this.imgUrl = null;
        return;
      }

      this.imgUrl = URL.createObjectURL(file);
      this.newOrder.image = file;
    },

    deleteImage() {
      this.newOrder.image = null,
      this.imgUrl = null,
      this.$refs.imageInput.value = "";
    },

    generateOrderNumber() {
      const timestamp = Date.now(); // Current timestamp in milliseconds
      const randomNumber = Math.floor(Math.random() * 1000000); // Random number between 0 and 999,999
      return `XRP-${timestamp}-${randomNumber}`;
    },

    // Create order payload for signing
    async pay() {
      if(!this.customerAcc || !this.isValidXRPAddress(this.customerAcc)){
        toast.error('Your XRPL address format is incorrect.\nTry signing out and in again.', { icon: false, });
        return;
      } 
      if(this.orderIsOverlaping == true) {
        toast.error('Your spot is overlapping with existing ones.\nTry selecting again.', { icon: false, });
        return;
      }

      if(this.newOrder.coords_x_left < 0 || this.newOrder.coords_x_left > 990 ||
        this.newOrder.coords_y_top < 0 || this.newOrder.coords_y_top > 990 ||
        this.newOrder.coords_x_right < 9 || this.newOrder.coords_x_right > 999 ||
        this.newOrder.coords_y_bottom < 9 || this.newOrder.coords_y_bottom > 999
      ) {
        toast.error('Something wrong with selected spot coordinates.\nTry selecting again.', { icon: false, });
        return;
      }

      if(this.newOrder.coords_x_left > (this.newOrder.coords_x_right - 9) ||
        this.newOrder.coords_y_top > (this.newOrder.coords_y_bottom - 9)
      ) {
        toast.error('Something wrong with selected spot size.\nTry selecting again.', { icon: false, });
        return;
      }

      if(this.newOrder.amount != (this.newOrder.px_horizontal * this.newOrder.px_vertical / 10)) {
        toast.error('Something wrong with XRP amount.\nTry selecting again.', { icon: false, });
      }

      this.forwardStep();

      this.newOrder.client_address = this.customerAcc;
      this.newOrder.number = this.generateOrderNumber();
      const destination = process.env.VUE_APP_SELLER_XRPL_ADDRESS;

      window.xumm.payload.createAndSubscribe(
        {
          TransactionType: 'Payment',
          Destination: destination,
          Amount: String(this.newOrder.amount * 1000000), // one million drops, 1 XRP
          Memos: [
            {
              Memo: {
                MemoData: this.hexEncode('number:' + this.newOrder.number),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('coords_x_left:' + this.newOrder.coords_x_left),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('coords_y_top:' + this.newOrder.coords_y_top),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('coords_x_right:' + this.newOrder.coords_x_right),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('coords_y_bottom:' + this.newOrder.coords_y_bottom),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('px_horizontal:' + this.newOrder.px_horizontal),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('px_vertical:' + this.newOrder.px_vertical),
              },
            },
            {
              Memo: {
                MemoData: this.hexEncode('px_horizontal:' + this.newOrder.px_horizontal),
              },
            }, 
            {
              Memo: {
                MemoData: this.hexEncode('affiliate_code:' + this.newOrder.affiliate_code),
              },
            },            
          ],
        },
        (eventMessage) => {
          console.log(eventMessage)
          if ('opened' in eventMessage.data && eventMessage.data.opened == true) {
            // Xaman app notification was opened
            toast.info('Payment opened in Xaman.\nNext step is to sign it.', { icon: false, });
          }

          if ('signed' in eventMessage.data && eventMessage.data.signed == false) {
            // Handle signed payload
            toast.error('Payment was not signed.\nTry again.', { icon: false, });
            this.paymentNotSigned = true
            this.paymentInfo.url = null
            this.paymentInfo.qr = null

          } else if('signed' in eventMessage.data && eventMessage.data.signed == true) {

            this.paymentNotSigned = false
            toast.success('Payment signed in Xaman.\nWait for confirmation info.', { icon: false, });

            if(!eventMessage.data.txid) {
              toast.error('Could not get Transaction ID.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload || !eventMessage.payload.application) {
              toast.error('Transaction payload empty.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.application.uuidv4 || eventMessage.payload.application.uuidv4 != process.env.VUE_APP_XAMAN_API_KEY) {
              toast.error('Transaction was signed by another app.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.payload.tx_destination || eventMessage.payload.payload.tx_destination != process.env.VUE_APP_SELLER_XRPL_ADDRESS) {
              toast.error('Payment sent to incorrect address.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.payload.computed) {
              toast.error('Could not resolve payment content from transaction.\nCheck your transaction and profile.', { icon: false, });

            } else if(!eventMessage.payload.payload.computed.Memos || 
            eventMessage.payload.payload.computed.Memos.length < 1) {
              toast.error('Could not resolve order details from transaction.\nCheck your transaction and profile.', { icon: false, });

            } else {
              // All good, update order with Tx data
              this.newOrder.client_address = eventMessage.payload.payload.request_json.Account
              this.newOrder.amount = eventMessage.payload.payload.request_json.Amount / 1000000
              this.newOrder.tx_hash = eventMessage.data.txid

              eventMessage.payload.payload.computed.Memos.forEach(memo => {
                // Remove the surrounding quotes
                const cleanedStr = memo.Memo.MemoData.replace(/^"|"$/g, '');
                // Split the string by the colon ':'
                const parts = cleanedStr.split(':');
                // Set key and value
                this.newOrder[parts[0]] = parts[1];
              });
              this.postNewOrder()
              
            }
          }
        }
      )
      .then(({ created }) => {
        this.paymentInfo.url = created.next.always;
        this.paymentInfo.qr = created.refs.qr_png;
      })
      
    },
    async postNewOrder() {
      this.waitingForPost = true;
      try {
        // Create FormData object
        const formData = new FormData();
        formData.append('number', this.newOrder.number);
        formData.append('client_address', this.newOrder.client_address);
        formData.append('amount', this.newOrder.amount);
        formData.append('coords_x_left', this.newOrder.coords_x_left);
        formData.append('coords_y_top', this.newOrder.coords_y_top);
        formData.append('coords_x_right', this.newOrder.coords_x_right);
        formData.append('coords_y_bottom', this.newOrder.coords_y_bottom);
        formData.append('url', this.newOrder.url);
        formData.append('display_text', this.newOrder.display_text);
        formData.append('twitter', this.newOrder.twitter);
        formData.append('discord', this.newOrder.discord);
        formData.append('affiliate_code', this.newOrder.affiliate_code);
        formData.append('tx_hash', this.newOrder.tx_hash);
        formData.append('image', this.newOrder.image);

        console.log(JSON.stringify(this.newOrder))
        // Make the POST request with FormData
        const response = await axios.post(process.env.VUE_APP_API_URL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data', // Ensure the request is multipart
          },
        });

        // Check if the response is successful
        if (response.data.success) {
          console.log('response=' + JSON.stringify(response));
          this.orders.push(response.data.order);
          this.paymentNotSigned = false;
          this.waitingForPost = false;
          this.orderCreated = true;
          this.newOrder = { ...response.data.order }; // Ensure reactivity
          toast.success('Your spot is added to Million XRP Wall!', { icon: false });
        }

        if (response.data.level === 'warning') {
          this.paymentNotSigned = false;
          this.waitingForPost = false;
          response.data.messages.forEach(msg => {
            toast.warning(msg, { icon: false });
          });
        } else if (response.data.level === 'error') {
          this.paymentNotSigned = false;
          this.waitingForPost = false;
          this.orderCreated = false;
          response.data.messages.forEach(msg => {
            toast.error(msg, { icon: false });
          });
        }

      } catch (error) {
        // Handle error
        this.paymentNotSigned = true;
        this.waitingForPost = false;
        this.orderCreated = false;
        this.letsCreateOrder = false;
        toast.error('There was a problem saving your order.\nCheck your profile or contact us.', { icon: false });
        console.error('Error adding order:', error);
      }
    }
  }
}
</script>

<style scoped>
.grid-container {
  position: relative;
  transform: translateZ(0);
  will-change: transform;
}

.grid-wrapper {
  z-index: 20;
  position: relative;
  overflow: hidden;
  align-items: center;
  display: flex;
  justify-content: center;
  background: url('http://millionpixelxrp.com/api/uploads/grid.jpg') no-repeat center center;
  background-size: contain;
  border: 0.1px solid white;
}

.orders-wrapper {
  z-index: 30;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  /*background: url('http://localhost:3000/api/uploads/grid.jpg') no-repeat center center;
  background-size: contain;
  border: 0.1px solid white;*/
  overflow: hidden;
}

.grid-wrapper,
.grid-wrapper img,
.orders-wrapper,
.drawn-div {
  aspect-ratio: 1;
}

.drawn-div {
  z-index: 21;
}

.order {
  position: absolute;
  z-index: 40;
  transform: translateZ(0);
  will-change: transform;
}

.order a, .order img {
  width: 100%;
  height: 100%;
  display: block;
  transform: translateZ(0);
  will-change: transform;
}

.order-hidden {
  display: none;
}

</style>
